import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { httpClient } from '@/api/http-client'
import { ManualPaymentSlip } from '@/types'

export type RegisterManualPaymentSlipDownloadParams = {
  company_key: string
  slip_key: string
}

export async function registerManualPaymentSlipDownload({
  company_key,
  slip_key,
}: RegisterManualPaymentSlipDownloadParams) {
  const response = await httpClient(
    'accounting-dealer',
  ).post<ManualPaymentSlip>(
    `/v3/company/${company_key}/manual-payment-slips/${slip_key}/download`,
  )

  return response.data
}

export function useRegisterManualPaymentSlipDownload(
  options?: UseMutationOptions<
    ManualPaymentSlip,
    AxiosError,
    RegisterManualPaymentSlipDownloadParams
  >,
) {
  return useMutation({
    mutationFn: registerManualPaymentSlipDownload,
    ...options,
  })
}
